export default __webpack_public_path__ + "static/media/sampleVRDoc.454fbe00.gif";